import { useMemo } from "react";

import { triviaGameSchema } from "../../../lib";
import {
  useRequestMutation,
  useRequestQuery,
  type UseRequestQueryProps,
} from "../../../request";
import { useSession } from "../../../session";
import { keyTrivia } from "./keyTrivia";
type UseRequestTriviaProps = UseRequestQueryProps & {
  id?: number;
  apiVersion?: string;
};
export const useRequestTrivia = ({
  id,
  apiVersion = process.env.NEXT_PUBLIC_X_HALLOW_VERSION,
  ...props
}: UseRequestTriviaProps) => {
  const { token } = useSession();

  const headers = useMemo(
    () => ({
      "X-Hallow-Version": apiVersion,
      Authorization: `Bearer ${token}`,
    }),
    [apiVersion, token],
  );

  return {
    query: useRequestQuery<typeof triviaGameSchema>({
      queryFnRequestProps: {
        urlBackendPath: `/trivia${!!id ? `/${id}` : ""}`,
        requestType: "authenticated",
        schema: triviaGameSchema,
        headers,
      },
      enabled: !isNaN(id),
      queryKey: keyTrivia(),
      ...props,
    }),
    mutationPost: useRequestMutation<
      any,
      { gameId: number; questionId: number; answerId: number; seconds: number }
    >({
      mutationFnRequestProps: ({ gameId, questionId, answerId, seconds }) => ({
        urlBackendPath: `/trivia/${gameId}/questions/${questionId}/answers`,
        method: "POST",
        body: JSON.stringify({
          seconds,
          answer_id: answerId,
        }),
        headers: {
          "X-Hallow-Version": apiVersion,
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  };
};
